import PageMain from '@/components/page-main';
import { useReducer } from 'react';
import useFetch from '@/hooks/useFetch';
import fetchValueReducer from '@/hooks/fetchValueReducer';
import { Table, Alert } from 'antd';

const Index: React.FC = () => {
  const [fetchValue, dispatchFetchValue] = useReducer(fetchValueReducer, { page: 1, size: 10, total: 1 });

  const { data, loading, fetchData } = useFetch("/local/knowledge/prediction", { ...fetchValue }, dispatchFetchValue)

  const contentStyle = { fontSize: "12px", maxHeight: 150, overflowY: 'auto' } as React.CSSProperties;

  return <PageMain>
    <Table
      dataSource={data}
      columns={[
        { title: 'ID', dataIndex: 'id', key: 'id' },
        {
          title: '输入',
          dataIndex: 'input',
          key: 'input',
          render: _ => <Alert
            style={{
              whiteSpace: 'pre-wrap',
            }}
            description={<div style={contentStyle}>{_}</div>}
            type="info"
          />
        },
        {
          title: '输出',
          dataIndex: 'output',
          key: 'output',
          render: _ => <Alert
            style={{
              whiteSpace: 'pre-wrap',
            }}
            description={<div style={contentStyle}>{_}</div>}
            type="success"
          />
        },
        {
          title: '提示词',
          dataIndex: 'prompt',
          key: 'prompt',
          width: '50%',
          render: _ => {
            const userContent = _.messages.find((vo: { role: string; content: string; }) => vo.role === 'user');
            if (!userContent) return <>-</>
            return <Alert
              style={{
                whiteSpace: 'pre-wrap',
              }}
              description={<div style={contentStyle}>{userContent.content}</div>}
              type="warning"
            />
          }
        },
        { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt' },
      ]}
      loading={loading}
      rowKey="id"
      pagination={{
        showSizeChanger: true,
        current: fetchValue.page,
        total: fetchValue.total,
        pageSize: fetchValue.size,
        pageSizeOptions: [10, 20, 50],
        onChange: (page, size) => {
          dispatchFetchValue({ type: 'update', value: { page, size } });
          fetchData();
        },
      }}
    />
  </PageMain>
}

export default Index;